const TOKEN_PREFIX = 'Bearer ';
const INVALID_TOKEN_LITERALS = ['null', 'undefined'];

export function effectiveBearerTokenValue(token) {
  if (token == null) return null;

  const trimmedToken = String(token).trim();
  if (!trimmedToken || INVALID_TOKEN_LITERALS.includes(trimmedToken.toLowerCase())) {
    return null;
  }

  let tokenValue = trimmedToken;
  while (tokenValue.toLowerCase().startsWith(TOKEN_PREFIX.toLowerCase())) {
    tokenValue = tokenValue.slice(TOKEN_PREFIX.length).trim();
  }

  if (
    !tokenValue
    || INVALID_TOKEN_LITERALS.includes(tokenValue.toLowerCase())
    || tokenValue.toLowerCase() === 'bearer'
  ) {
    return null;
  }

  return tokenValue;
}

export function hasEffectiveBearerToken(token) {
  return effectiveBearerTokenValue(token) != null;
}

export function effectiveAuthorizationHeader(token) {
  const tokenValue = effectiveBearerTokenValue(token);
  return tokenValue ? `${TOKEN_PREFIX}${tokenValue}` : null;
}

function withoutAuthorizationHeader(headers) {
  return Object.keys(headers).reduce((sanitizedHeaders, headerName) => {
    if (headerName.toLowerCase() !== 'authorization') {
      return {
        ...sanitizedHeaders,
        [headerName]: headers[headerName],
      };
    }

    return sanitizedHeaders;
  }, {});
}

function isInvalidAuthorizationHeader(value) {
  if (value == null) return true;

  const normalizedValue = String(value).trim().toLowerCase();
  return [
    '',
    'bearer',
    'bearer null',
    'bearer undefined',
    'null',
    'undefined',
  ].includes(normalizedValue);
}

function sanitizeInvalidAuthorizationHeader(headers) {
  return Object.keys(headers).reduce((sanitizedHeaders, headerName) => {
    if (
      headerName.toLowerCase() === 'authorization'
      && isInvalidAuthorizationHeader(headers[headerName])
    ) {
      return sanitizedHeaders;
    }

    return {
      ...sanitizedHeaders,
      [headerName]: headers[headerName],
    };
  }, {});
}

export function applyCookieCredentials(config = {}) {
  return {
    ...config,
    headers: sanitizeInvalidAuthorizationHeader(config.headers || {}),
    withCredentials: true,
  };
}

export function applyBearerOrCookie(baseConfig = {}, bearerTokenString = null) {
  const merged = {
    ...baseConfig,
    headers: withoutAuthorizationHeader(baseConfig.headers || {}),
    withCredentials: true,
  };
  const authorizationHeader = effectiveAuthorizationHeader(bearerTokenString);

  if (authorizationHeader) {
    merged.headers.Authorization = authorizationHeader;
  }

  return merged;
}
